export default __webpack_public_path__ + "a944393b2dba387a72997d4c673a073c.png";